import React, { useState } from "react";
import axios from "axios";
import {
  Icon,
  Button,
  OverlayToaster,
  Position,
  Intent,
  Alert
} from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { APIURL } from "../../config";

export function AddToCart(editor) {
  const [saveloader, setsaveloader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [redirection, setRedirection] = useState(false);

  const handleCancel = () => { setIsOpen(false) };

  const handleConfirm = () => {
    setIsOpen(false);
    window.location.href = redirection;
  };

  const {
    sessionId,
    apiUrl,
    cartKey,
    loadCategories,
    canvases,
    canvasObjects,
    images,
    TemplateData,
    CategoriesData,
    setLoader
  } = editor;

  // Save & Download.
  const svgToSVG = async () => {
    setsaveloader(true);
    setLoader(true);
    if (sessionId && apiUrl && cartKey && loadCategories) {
      if (sessionId && typeof sessionId !== "undefined") {

        let allPagesObjects = [];

        if (canvasObjects.length > 0) {
          const api_url = atob(atob(apiUrl));

          const encodedData = JSON.stringify({
            session_id: sessionId,
            cart_key: cartKey,
          });

          // Set canvas object for all pages.
          canvasObjects.forEach((allPageObjects, pageIndex) => {
            canvases[pageIndex].discardActiveObject();
            canvases[pageIndex].renderAll();
            const BGColor =
              canvases[pageIndex]
                ? canvases[pageIndex].backgroundColor
                : "";
            const canvasImg =
              canvases[pageIndex]
                ? canvases[pageIndex].toDataURL("image/png")
                : "";
            const canvasObj =
              canvases[pageIndex]
                ? canvases[pageIndex].toSVG()
                : "";
            const pagesObjects = {
              bg_color: BGColor,
              image: canvasImg,
              canvas_data: canvasObj,
            };
            allPagesObjects.push(pagesObjects);
          });

          const formData = new FormData();

          if (TemplateData) {
            const { jsPDF } = await import('jspdf');
            // const widthMM = 8.5 * 25.4;
            // const heightMM = 11 * 25.4;
            const widthMM = parseInt(TemplateData.sheetWidth) * 25.4;
            const heightMM = parseInt(TemplateData.sheetHeight) * 25.4;
            const pdf = new jsPDF({
              orientation: CategoriesData.pr_file_size == 'P' ? 'portrait' : "landscape",
              unit: 'mm',
              format: [widthMM, heightMM],
              compress: true,
            });

            for (let i = 0; i < images.length; i++) {
              if (i > 0) pdf.addPage();
              pdf.addImage(images[i], 'PNG', 0, 0, widthMM, heightMM);
            }
            const pdfBase64 = pdf.output('dataurlstring');
            const pdfFile = base64ToFile(pdfBase64, 'document.pdf');
            formData.append('pdf', pdfFile);
          }

          for (let index = 0; index < images.length; index++) {
            const element = images[index];
            let imageFile = base64ToFile(element, 'preview_' + index + '.png')
            formData.append('images[]', imageFile);
          }

          const response = await axios.post(`${APIURL}/api/v1/save-image-pdf`, formData);
          console.log("response.data", response.data);
          let SavePdfImageUrl = response.data.data

          axios
            .post(api_url, {
              token: btoa(encodedData),
              canvas_size: localStorage.getItem("canvas_size"),
              pr_file_size: localStorage.getItem("pr_file_size"),
              page_details: allPagesObjects,
              ...SavePdfImageUrl
            })
            .then(function (response) {
              setsaveloader(false);
              setLoader(false);
              if (response.data.data.message) {
                // window.location.href = response.data.data.cart_url;
                setRedirection(response.data.data.cart_url);
                setIsOpen(true);
              } else {
                // alert(response.data.data.error);
                OverlayToaster.create({
                  position: Position.TOP_RIGHT,
                  maxToasts: 1,
                  autoFocus: false,
                  canEscapeKeyClear: true,
                }).show({
                  message: response.data.data.error,
                  intent: Intent.DANGER,
                  icon: "error",
                  timeout: 3000,
                });
              }
            })
            .catch(function (error) {
              setsaveloader(false);
              setLoader(false);
              console.log(error);
              OverlayToaster.create({
                position: Position.TOP_RIGHT,
                maxToasts: 1,
                autoFocus: false,
                canEscapeKeyClear: true,
              }).show({
                message: "Oops!something went wrong during save.",
                intent: Intent.DANGER,
                icon: "error",
                timeout: 3000,
              });
            });
        }
      } else {
        setLoader(false);
        setsaveloader(false);
        // alert("Unauthorized information.");
        OverlayToaster.create({
          position: Position.TOP_RIGHT,
          maxToasts: 1,
          autoFocus: false,
          canEscapeKeyClear: true,
        }).show({
          message: "Unauthorized information.",
          intent: Intent.DANGER,
          icon: "error",
          timeout: 3000,
        });
      }
    }
  };
  const base64ToFile = (base64, filename) => {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  return (
    <div className="bp4-navbar-group bp4-align-right margin-left-10">
      {saveloader && <Button icon={<Icon icon="saved" />} text="Loading..." />}
      {!saveloader && (
        <>
          <Button
            onClick={svgToSVG}
            // icon={<Icon icon="saved" />}
            icon={<Icon icon="shopping-cart" />}
            text="Save and add to cart"
          />
          <Alert
            cancelButtonText="Continue Editing"
            confirmButtonText="Go to Cart"
            icon={IconNames.SAVED}
            intent={Intent.SUCCESS}
            isOpen={isOpen}
            onCancel={handleCancel}
            onConfirm={handleConfirm}
          >
            <p>
              Your design has been successfully saved! Click 'Cancel' to
              continue editing, or click 'Go to Cart' to proceed with your
              purchase.
            </p>
          </Alert>
        </>
      )}
    </div>
  );
}
